import { render } from "./Orcamento.vue?vue&type=template&id=50dbd91b"
import script from "./Orcamento.vue?vue&type=script&lang=ts"
export * from "./Orcamento.vue?vue&type=script&lang=ts"

import "./Orcamento.vue?vue&type=style&index=0&id=50dbd91b&lang=css"
script.render = render

export default script